module.exports = __webpack_public_path__ + "img/logo-deeners-kebab.04173878.png";